export const createMetainfoString = (array: string[], label: string) => {
    return array.length > 0 ? `"${label}","${array.join('; ')}",,,\n` : '';
};
